/**
 * Non-text configuration for the `/home` landing page.
 * Replace the YouTube IDs with the real product demo videos before launch.
 * Videos play sequentially on a loop via the YouTube IFrame API.
 * User-facing text lives in ../labels/landingLabels.js.
 */
export const LANDING_CONFIG = Object.freeze({
  VIDEO: {
    YOUTUBE_IDS: ["16KttUtAZvw", "n7-0W4367UQ"],
    LOOP: true,
  },
  LINKS: {
    SIGN_IN: "/login",
    CREATE_ACCOUNT: "/register",
    FREE_SIGN_UP: "/register",
    CONTACT_US: "https://ziniz.online/ContactSupport/",
  },
});
